import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

function DeltaIcon(props: SvgIconProps) {
	return (
		<SvgIcon viewBox="0 0 24 24" {...props}>
			<path
				d="M12 4L4 20H20L12 4Z"
				stroke="currentColor"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
				fill="none"
			/>
		</SvgIcon>
	);
}

export default DeltaIcon;
